<template>
  <Layout :config="config" class="tjxd">
    <template v-slot:header>
      <Header :config="config.navMenuConfig"
          :menus="config.menuList"
          :menuClass="menuClass"/>
      <div class="menuBox pc">
        <NavMenu
          class="nav-menu"
          :config="config.navMenuConfig"
          :menus="config.menuList"
          :menuClass="menuClass"
        />
      </div>
    </template>

    <template v-slot:main>
      <router-view class="main-content"></router-view>
    </template>

    <template v-slot:footer>
      <Footer />
    </template>
  </Layout>
</template>

<script>
import "../plugins/element/element.js";

import Layout from "@/components/Layout.vue";
import NavMenu from "@/components/NavMenu.vue";

import Header from "./Header.vue";
import Footer from "./Footer.vue";
import util from "@/libs/util.js";
import config from "../config.js";

export default {
  name: "Page",
  data() {
    return {
      config: {},
      menuClass: "subMenuClass",
    };
  },
  created() {
    util.setIcon("favicon.ico","天津现代职业技术学院人民数字马院")
    this.config = config;
  },
  components: {
    Layout,
    NavMenu,
    Header,
    Footer,
  },
};
</script>

<style lang="scss">

</style>

<style lang="scss" scoped>
@import "../variables.scss";
// @import "@/assets/font_1589680_w5il09oag4/iconfont.css";
.banner {
  display: block;
  height: 200px;
  background-color: rgb(211, 220, 230);
}
.menu-container {
  background-color: $menu-color;
  height: 50px;
  line-height: 50px;
}
.menuBox {
  font-size: 16px;
}
.nav-menu {
  position: relative;
  margin: -25px auto 0;
  border-radius: 4px;
  background-color: #ffaf2a;
  /deep/.menu-item:hover {
    background-color: $menu-hoverColor !important;
  }
  /deep/.menu-item.is-active {
    font-weight: bold;
    border: unset;
    background-color: $menu-activeColor !important;
  }
  /deep/.menu-item:hover .el-submenu__title {
    background-color: $menu-hoverColor !important;
  }
  /deep/.menu-item.is-active .el-submenu__title {
    font-weight: bold;
    border: unset !important;
    background-color: $menu-activeColor !important;
  }
}

.main-content {
  min-height: 100%;
 background-color: #fff9f6;
  background-image: url("~@/assets/images/tjxd/background.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom;
  overflow-x: hidden;
  margin-top: -25px;
  padding-top: 25px;
}
@media (max-width: 767px) {
  .main-content {
    background-color: #fff;
    background-image: unset
  }
}
</style>
<style lang="scss">
@import "../variables.scss";
.subMenuClass .menu-item.is-active {
  background-color: $menu-activeColor !important;
}
.subMenuClass .menu-item:hover {
  background-color: $menu-hoverColor !important;
}
// 公共样式
.tjxd {
  .can-click:hover .name {
    color: #ec2f08;
  }
}

#app .tjxd {
  .el-button--danger {
    color: #fff;
    background-color: #ec2f08;
    border-color: #ec2f08;
  }

  .el-button--danger:focus,
  .el-button--danger:hover {
    background-color: #ef5839;
    border-color: #ef5839;
    color: #fff;
  }

  .el-button--danger.is-plain {
    color: #ec2f08;
    background-color: #fff;
    border-color: #ec2f08;
  }

  .el-button--danger.is-plain:focus,
  .el-button--danger.is-plain:hover {
    background-color: #ef5839;
    border-color: #ef5839;
    color: #fff;
  }

  .el-pager li:hover {
    border-color: #ec2f08;
  }

  .el-pager li.active {
    color: #fff;
    border-color: #ec2f08;
    background-color: #ec2f08;
  }

  .card-shadow {
    box-shadow: 0 2px 8px 0 rgba(96, 30, 30, 0.05);
  }

  .card-shadow.has-hover:hover {
    box-shadow: 0 4px 12px 0 rgba(115, 0, 0, 0.15);
  }
}
</style>
